// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3Dr01","colMaxWidth":"Table_colMaxWidth__2179A"};